module.exports = __webpack_public_path__ + "static/icon5-9a766a41d4854e9340cfbbf62bb21c99.svg";